import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const mailServices = {
  addNewMailTemplate,
  updatedMailTemplate,
  softDeleteRestoreMailTemplate,
  deleteMailTemplate,
  getMailTemplateList,
  getSingleMailTemplate
};

// Add New Mail Template
async function addNewMailTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewMailTemplate`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Mail Template
async function updatedMailTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedMailTemplate`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Mail Template
async function softDeleteRestoreMailTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreMailTemplate`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Mail Template
async function deleteMailTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteMailTemplate`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Mail Template
async function getMailTemplateList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getMailTemplateList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getMailTemplateList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get All Mail Template
async function getSingleMailTemplate(formId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleMailTemplate/${formId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}